/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1513
 */

module.exports = {
  container: "WidgetSize_container__VTzhl"
}
